import { useQueries } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { ChangeItemType } from '@/features/dashboard/bookingChanges/types/dto/ChangeItemDto.ts';
import { BookingChangeKind } from '@/features/dashboard/bookingChanges/types/dto/BookingChangeKind.ts';
import { ChangePackageHistoryVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';

/**
 * Uzasadnienia rezygnacji, po jednym na paczkę — `id paczki` → tekst.
 *
 * Lista paczek uzasadnienia nie niesie: siedzi ono w pozycji `WITHDRAWAL`,
 * a tę widać dopiero w szczegółach. Dociągamy je więc **wyłącznie dla
 * rezygnacji**, których rezerwacja ma najwyżej kilka — historia edycji zostaje
 * jednym żądaniem, tak jak była.
 */
const useWithdrawalJustifications = (
  bookingId: string,
  history: ChangePackageHistoryVm[],
): Record<string, string> => {
  const withdrawals = history.filter(
    (entry) => entry.kind === BookingChangeKind.WITHDRAWAL,
  );

  const results = useQueries({
    queries: withdrawals.map((entry) => ({
      queryKey: bookingChangesApiQueryKeys.change(bookingId, entry.id),
      queryFn: () => bookingChangesApi.getChange(bookingId, entry.id),
      staleTime: Infinity,
    })),
  });

  return Object.fromEntries(
    results.flatMap((result) => {
      const change = result.data;
      const item = change?.items.find(
        (candidate) => candidate.type === ChangeItemType.WITHDRAWAL,
      );
      return item ? [[change!.id, item.justification]] : [];
    }),
  );
};

export default useWithdrawalJustifications;
